class WtUrls {
  constructor() {
    // URLs
    this.imageBaseUrl = "https://storage.googleapis.com/wt_resources/images"
    this.templateimgBaseUrl = "https://storage.googleapis.com/wt_resources/templatesimg"
    this.logoUrl = 'https://storage.googleapis.com/wt_resources/images/wtb_green_round_images.png'

    this.blogUrl = 'https://blog.whatstool.business/'

    // App Urls
    this.whatstoolAppUrl = 'https://play.google.com/store/apps/details?id=com.whatstools.statussaver.directchat.trendingstatus.searchprofile'
    this.whatstoolBusinessAppUrl = 'https://play.google.com/store/apps/details?id=in.wtb'
    this.whatsSaveAppUrl = 'https://play.google.com/store/apps/details?id=com.whatstool.whatssave.exportcontact.autosave'
    this.instaramAppUrl = 'https://play.google.com/store/apps/details?id=igtool.toolsforinstagram.instagramphotodownloader.instagramvideodownloader.repost'
    this.appDeveloperUrl = 'https://play.google.com/store/apps/developer?id=WhatsTool+Tech:+Toolkit+for+Business+%26+WhatsApp'
    this.wtDesktopAppUrl = 'https://raw.githubusercontent.com/love-building-app/letsserve/master/prod/home/desktop/WhatsTool.zip'
    // End of URLs


    this.testURL = '934b863-testing-wtb-7b863.web.app'

    this.appProdLink = 'https://app.whatstool.business'
    this.appTestLink = 'https://934b863-testing-wtb-7b863.web.app'
    
    this.staticLink = 'https://934b863-testing-wtb-7b863.web.app/auth'
    this.productionLink = 'https://app.whatstool.business/auth'


    this.productionTemplateLink = 'https://app.whatstool.business/settings/templates-create?data='
    this.appTestingTemplateLink = 'https://934b863-testing-wtb-7b863.web.app/settings/templates-create?data='


    this.dashboardUrl = "/app"


    this.paymentPlanSubscriptionUrl = "/app/payment/plan-subscription"

    this.wtdPaymentUrl = "/wtd-payment"

    this.whastsappchatbuttonUrl = "/whatsapp-chat-button"
    this.whatsappLinkGeneratorUrl = "/whatsapp-link-generator"
    this.whatsappQRGeneratorUrl = "/whatsApp-QR-code-generator"
    this.WhatsToolPricingCalcultorUrl = "/pricing-calculator"

    this.featuredTemplatesUrl = '/whatsapp-chatbot-template'
    this.CompareWatiUrl = '/wati-compare'
    this.marketingPageUrl = '/marketing'
    this.salesPageUrl = '/sales'
    this.customerSupportPageUrl = '/customer-support'

    this.paymentUrl = "/app/payment"
    this.paymentCompletionUrl = "/app/completion"



    // Static Pages URls
    this.whatsappBusinessApiUrl = "/whatsApp-business-api"
    this.crmUrl = "/crm"
    this.intergrationUrl = "/integration"
    this.educationalSectorUrl = "/industry/educational-sector-industry"
    this.ecommerceSectorUrl = "/industry/ecommerce-sector-industry"
    this.healthSectorUrl = "/industry/health-sector-industry"
    this.tourTravelSectorUrl = "/industry/tour-travel-sector-industry"
    this.HotelsHospitalitySectorUrl = "/indutry/Hotels-Hospitality-Sector-industry"
    this.pricingUrl = "/whatsapp-api-pricing"

    this.teamPageUrl = '/team'
    this.conversationalEngagementUrl = '/conversational-engagement'

    this.powerBusinessUrl = '/power-business'
    this.PartnershipPageUrl = '/partnership'
    this.CaseStudyUrl = '/case-study'
    this.MaintenanceUrl = '/maintenance'
    this.WhatstoolTemplatesUrl = '/whatsapp-message-templates'

    this.UrlShortnerLink = '/tiny/:tiny'

    this.quickGuideUrl = "/quick-guide"
    this.chatbotsUrl = "/chatbots"
    this.multiAgentsUrl = "/whatsapp-multi-agent"
    this.multiagentUrl = "/multi-agents"  // Old URL
    this.broadcastMessageUrl = "/broadcast-message"
    this.clientsUrl = "/clients"

    this.supportUrl = "/support"
    this.contactUsUrl = "/contact-us"
    this.termsOfServiceUrl = "/terms-of-service"
    this.privacyPolicyUrl = "/privacy-policy"
    this.cancellationUrl = "/cancellation"
  }
}
export const getUrl = new WtUrls()